var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondenced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 14.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #428bca;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1742388_cc",
    transform: "translate(-2.5 -14.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(2.5 14.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-1",
    d: "M6.9,30.163a12.733,12.733,0,0,1-2.547-2.105,1.017,1.017,0,0,1,0-1.411A11.211,11.211,0,0,1,12.5,22.9a12.013,12.013,0,0,1,1.537.105l1.347-1.347A12.43,12.43,0,0,0,12.5,21.3a12.938,12.938,0,0,0-9.305,4.253,2.652,2.652,0,0,0,0,3.579A14.185,14.185,0,0,0,5.742,31.3Z",
    transform: "translate(-2.5 -19.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-1",
    d: "M48.489,33.368A14.426,14.426,0,0,0,45.921,31.2l-1.137,1.137a12.733,12.733,0,0,1,2.547,2.105,1.017,1.017,0,0,1,0,1.411A11.211,11.211,0,0,1,39.184,39.6a12.013,12.013,0,0,1-1.537-.105L36.3,40.842a12.43,12.43,0,0,0,2.884.358,12.853,12.853,0,0,0,9.305-4.232,2.623,2.623,0,0,0,.695-1.789A2.674,2.674,0,0,0,48.489,33.368Z",
    transform: "translate(-29.184 -27.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-1",
    d: "M33.3,36.816a3.269,3.269,0,0,0,.063.653l4.105-4.105a3.427,3.427,0,0,0-.653-.063A3.522,3.522,0,0,0,33.3,36.816Z",
    transform: "translate(-26.816 -29.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-1",
    d: "M47.553,50.989a3.522,3.522,0,0,0,3.516-3.516,3.648,3.648,0,0,0-.063-.674L46.9,50.926A3.269,3.269,0,0,0,47.553,50.989Z",
    transform: "translate(-37.553 -39.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-1",
    d: "M29.138,14.612a.775.775,0,0,0-1.116,0L14.612,28.022a.775.775,0,0,0,0,1.116.813.813,0,0,0,.568.232.852.852,0,0,0,.568-.232L29.18,15.707A.79.79,0,0,0,29.138,14.612Z",
    transform: "translate(-11.875 -14.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondenced);
export default __webpack_public_path__ + "static/media/condenced.8147b3706eb66a9f55dc2de58911f833.svg";
export { ForwardRef as ReactComponent };